// extracted by mini-css-extract-plugin
module.exports = {"description":"premium-PaymentStep__description--LoR1s","title":"premium-PaymentStep__title--2TKDn","formContainer":"premium-PaymentStep__formContainer--z6PQN"};